import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { msalConfig } from '../../core/guards/msal-config';
import * as constant from '../../shared/constants/constants';
import { UtilService } from 'src/app/shared/services/util.service';
import { MsalService } from '@azure/msal-angular';
import { StorageService } from 'src/app/shared/services/storage.service';
import { localStorageKeys} from '../enum';
import { jwtDecode } from 'jwt-decode';
import { UrlSecurityService } from 'src/app/shared/services/url-security.service';
import { AuthenticationResult } from '@azure/msal-browser';
import { environment } from './../../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  tokenSubject = new BehaviorSubject<any>(null);

  constructor(
    private router: Router,
    private utilService: UtilService,
    private msalService: MsalService,
    private storageService: StorageService,
    private urlSecurityService: UrlSecurityService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipMarketHeader = request.headers.get(constant.common.skip_market);
    return from(this.getAccessToken()).pipe(
      switchMap((tokenDetails:any) => {
        const [accessToken, market] = tokenDetails;
        let headers = request.headers;
        if (accessToken) {
          headers = headers.set(constant.common.authorization, constant.common.bearer + accessToken);

          if (skipMarketHeader) {
            headers = headers.delete(constant.common.skip_market);
          } else if (market) {
            //headers = headers.set(constant.common.authorization, constant.common.bearer + accessToken + '|' + this.urlSecurityService.encrypt(market)); //remove this once akamai is resolved
            headers = headers.set('x-market', this.urlSecurityService.encrypt(market)); 
          }
        }
        request = request.clone({ headers });
        return next.handle(request);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === constant.common.unauthorizeStatusCode) {
          this.msalService.logoutRedirect(); // Redirect to login on 401
        }
        throw error;
      })
    );
  }

    private async getAccessToken(): Promise<any> {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length === 0) {
      const market = await this.storageService.get(localStorageKeys.market)
      return [null, market];
    }

    try {
      const result: AuthenticationResult = await this.msalService.instance.acquireTokenSilent({
        scopes: [environment.AUDIANCE], // Replace with your API scope
        account: accounts[0],
      });
      const market = await this.storageService.get(localStorageKeys.market)
      return [result.accessToken, market];
    } catch (error:any) {
      return [null,null];
    }
  }
}
